import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../_common/components/ButtonAction';
import {useCustomerDetailsUIContext} from '../CustomerDetailsUIContext';

const ButtonCreateClient = () => {
  const {
    createClient: {
      createGreenInvoiceClientForCurrentCustomer,
      creatingClient,
    }
  } = useCustomerDetailsUIContext();

  const handleClick = () => {
    if (!creatingClient) {
      createGreenInvoiceClientForCurrentCustomer();
    }
  };

  return (
    <ButtonAction
      variant={'warning'}
      onClick={handleClick}
      useIcon={'/media/common/GI-logo.svg'}
      label={<FormattedMessage id="green-invoice-create-client-button" defaultMessage="Create client"/>}
      disabled={creatingClient}
      customClassnames={'mt-10 mx-auto d-block'}
    />
  );
};

export default ButtonCreateClient;
